"use client"

import * as React from "react"
import { cn } from "../lib/utils.ts"
import { Switch as SwitchPrimitive } from "radix-ui"

/*
 * shadcn/ui Switch, restyled (components.md, Selection controls): a 32 x 18 track (24 x 14
 * small) with a white thumb that slides 120 ms on the standard curve. On is the control colour (the control gradient's mid, solid); off is
 * the --border-control grey, so the track itself meets 3:1 against any surface. Takes effect
 * now; never inside a form with a Save button.
 */
function Switch({
  className,
  size = "default",
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & {
  size?: "sm" | "default"
}) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      className={cn(
        "peer inline-flex shrink-0 items-center rounded-full transition-colors duration-(--duration-fast) ease-standard disabled:cursor-not-allowed data-[size=default]:h-4.5 data-[size=default]:w-8 data-[size=sm]:h-3.5 data-[size=sm]:w-6 data-[state=checked]:bg-(--control-mid) data-[state=unchecked]:bg-input hover:data-[state=unchecked]:bg-fg-subtle disabled:data-[state=checked]:bg-active disabled:data-[state=unchecked]:bg-active",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        data-size={size}
        className={cn(
          "pointer-events-none block rounded-full bg-white shadow-control ring-0 transition-transform duration-(--duration-fast) ease-standard data-[size=default]:size-3.5 data-[size=sm]:size-2.5 data-[state=unchecked]:translate-x-0.5 data-[state=checked]:bg-(--control-fg) data-[size=default]:data-[state=checked]:translate-x-4 data-[size=sm]:data-[state=checked]:translate-x-3 data-disabled:bg-fg-faint"
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
